export default __webpack_public_path__ + "static/media/IMG_1959.ca394e4c.jpg";